<template>
  <payButton />
</template>
<script>
import payButton from "../payButtonSDK";
export default {
  components: {
    payButton
  }
};
</script>
